import { useCallback } from 'react';
import useDisplayUnitsCustomEventBindings from 'state/hooks/useDisplayUnitsCustomEventBindings';
import { usePageData } from 'state/pageData';
import { CustomTrackingEvent } from 'types';
import { AppTrackingEvent } from '../types';
import { isUnitEvent } from '../utils';
import { loadTrackingIframe, loadTrackingPixel } from './utils';

function dispatchEvent(event: CustomTrackingEvent, root: HTMLElement | null) {
  if (event.deliveryMethod === 'iframe') {
    loadTrackingIframe(event.url, root ?? undefined);
  } else if (event.deliveryMethod === 'pixel') {
    loadTrackingPixel(event.url, root ?? undefined);
  }
}

export default function useExternalDispatch() {
  const bindings = useDisplayUnitsCustomEventBindings();
  const { reactRoot } = usePageData();

  return useCallback(
    (event: AppTrackingEvent) => {
      const eventType = event.event;
      const eventBindings = bindings?.[eventType];

      if (isUnitEvent(event)) {
        eventBindings?.forEach((binding) => {
          if (binding.unitId === event.payload.resultId) {
            dispatchEvent(binding, reactRoot);
          }
        });
      } else {
        eventBindings?.forEach((binding) => dispatchEvent(binding, reactRoot));
      }
    },
    [bindings, reactRoot],
  );
}
